<template>
  <div class="add-new-modal">
    <div class="add-new-modal__title">{{ modalConfig.title }}</div>
    <div class="add-new-modal__content">
      <div v-for="field in modalConfig.fieldsConfig" :key="field.property" class="add-new-modal__field-row">
        <div class="add-new-modal__field-title">
          {{ field.label }}
        </div>
        <base-select
                 class="add-new-modal__field"
                 :class="{'add-new-modal__field_err': errorFields.includes(field.property)}"
                 alignLeft
                 shiftLabelRight
                 :isSmartInput="field.isSmartInput"
                 placeholder="— Not Selected —"
                 :options="field.options"
                 :disabled="disableUsage"
                 :selectStyle="{height: '60px!important'}"
                 v-model="modelValues[field.property]"/>
      </div>
    </div>
    <div class="add-new-modal__footer">
      <button class="add-new-modal__button add-new-modal__button_cancel"
              :class="{'add-new-modal__button_disable': disableUsage}"
              @click.prevent="cancel()">
        Cancel
      </button>
      <button class="add-new-modal__button add-new-modal__button_submit"
              :class="{'add-new-modal__button_disable': disableUsage}"
              @click.prevent="apply()">
        Save
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddNewModal',
  props: {
    modalConfig: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      errorFields: [],
      modelValues: {},
      disableUsage: false
    }
  },
  methods: {
    ...mapActions('userManager', ['createNewUserRole']),
    cancel () {
      this.$emit('close', false)
    },
    async apply () {
      const errorFields = []
      // eslint-disable-next-line camelcase
      const { role_id, client_id, agency_id } = this.modelValues
      const roleOptions = this.modalConfig.fieldsConfig.find(i => i.property === 'role_id').options.map(i => i.value)

      if (!roleOptions.includes(role_id)) {
        errorFields.push('role_id')
      }

      if (this.modalConfig.type === 'agency') {
        const agencyOptions = this.modalConfig.fieldsConfig.find(i => i.property === 'agency_id').options.map(i => i.value)

        if (!agencyOptions.includes(agency_id)) {
          errorFields.push('agency_id')
        }
      } else if (this.modalConfig.type === 'client') {
        const clientOptions = this.modalConfig.fieldsConfig.find(i => i.property === 'client_id').options.map(i => i.value)

        if (!clientOptions.includes(client_id)) {
          errorFields.push('client_id')
        }
      } else {
        this.$emit('close')
      }

      this.errorFields = errorFields
      if (errorFields.length) {
        return
      }

      this.disableUsage = true
      const isCreated = await this.createNewUserRole({
        ...this.modelValues,
        type: this.modalConfig.type,
        user_id: this.modalConfig.userId
      })

      if (isCreated) {
        this.$emit('close')
      } else {
        this.disableUsage = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .add-new-modal {
    padding: 40px;

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }

      &_disable {
        pointer-events: none;
        opacity: .5;
      }
    }

    &__footer {
      margin-top: 40px;
      display: flex;
      justify-content: flex-end;
    }

    &__field-title {
        font-weight: bold;
        line-height: 20px;
    }

    &__field {
      &_err {
        border: 1px solid $rfx-light-red;
      }
    }

    &__field-row {
      &:last-child {
        margin-top: 30px;
      }
    }

    &::v-deep .select__list_top {
      max-height: 225px !important;
    }
  }
</style>
